var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUniqueDesign(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 247,
    height: 190,
    viewBox: "0 0 247 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M83.4426 95.9859L65.2002 88.7241V144.008L83.4309 151.412C84.0186 130.382 83.7482 114.406 83.4426 95.9859Z",
    fill: "#E5DDF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.5422 98.8079L83.4427 95.9858C83.7483 114.406 84.0186 130.382 83.4309 151.412L90.3894 154.234C90.3894 154.139 90.4246 154.057 90.4246 153.962C90.9888 133.877 90.8243 116.543 90.5422 98.8079Z",
    fill: "#F89DBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.302 98.1939L117.377 109.482L90.5305 98.8079C90.8008 116.555 90.9771 133.877 90.4129 153.962C90.4129 154.057 90.3894 154.139 90.3777 154.234L117.377 165.192L148.772 151.695C148.596 151.27 148.49 150.81 148.49 150.314L148.302 98.1821V98.1939Z",
    fill: "#E5DDF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.543 148.802L174.232 140.773V88.7241L155.343 95.6199L155.543 148.802Z",
    fill: "#E5DDF6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.343 95.2185V95.6199L155.542 148.802L148.784 151.707C148.608 151.282 148.502 150.822 148.502 150.326L148.314 93.0222L97.4065 75.9599L106.645 74.2241L155.354 90.4717V95.2185H155.343Z",
    fill: "#F89DBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.232 140.773L117.377 165.203V102.752L65.2002 82.0172L115.179 72.6182",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.787 129.709C202.806 128.056 208.507 128.587 213.126 131.15C217.745 133.712 221.248 138.258 222.541 143.406C223.27 146.299 223.223 149.653 221.307 151.932C219.391 154.21 215.183 154.482 213.714 151.884C212.103 149.027 214.783 145.555 217.663 143.985C223.787 140.643 231.768 141.08 237.504 145.048C243.24 149.015 246.473 156.371 245.544 163.302",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.6819 108.538C33.3816 114.961 29.491 123.711 28.9386 132.696C28.8328 134.468 28.8681 136.333 29.7144 137.88C30.5607 139.427 32.4648 140.537 34.1222 139.923C36.0498 139.226 36.6375 136.522 35.662 134.716C34.6864 132.909 32.6411 131.941 30.6194 131.563C26.1881 130.748 21.3924 132.484 18.4892 135.944C15.5859 139.403 14.7043 144.445 16.2441 148.696",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.507 71.1541C196.952 67.2457 201.901 65.3919 205.862 66.6435C209.823 67.8952 212.668 71.591 213.82 75.6057C214.49 77.9436 214.631 80.5532 213.514 82.7022C212.397 84.8512 209.717 86.2918 207.461 85.418C204.075 84.1191 204.252 78.6049 207.214 76.5149C210.176 74.4249 214.348 75.1097 217.534 76.8455C226.091 81.486 229.805 93.4119 225.386 102.126",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9995 1.59414C49.4733 -0.602117 44.4307 0.991942 42.0682 4.41622C39.7056 7.84049 39.7173 12.5282 41.2571 16.4012C42.1504 18.6565 43.6432 20.8173 45.8412 21.821C48.0393 22.8246 51.0248 22.3169 52.2825 20.2387C54.1632 17.1215 50.6604 12.8706 47.0284 13.0596C43.3964 13.2485 40.5401 16.3421 39.0826 19.6838C35.1567 28.6223 39.5175 40.3357 48.3214 44.492",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3619 62.6052C23.8726 63.113 6.37068 76.2197 0.587646 93.8724",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.103 148.318C135.913 165.133 146.01 180.849 160.526 189.41",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.443 6.3645C185.633 23.1789 175.536 38.8951 161.02 47.4558",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.683 26.91C124.229 29.6376 122.102 31.8575 119.481 51.057C116.86 31.8575 114.732 29.6494 96.2781 26.91C114.732 24.1824 116.86 21.9625 119.481 2.76294C122.102 21.9625 124.229 24.1706 142.683 26.91Z",
    fill: "#21187F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.5347 177.035C48.7808 177.035 50.6016 175.206 50.6016 172.95C50.6016 170.693 48.7808 168.864 46.5347 168.864C44.2886 168.864 42.4678 170.693 42.4678 172.95C42.4678 175.206 44.2886 177.035 46.5347 177.035Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.793 172.949C193.039 172.949 194.86 171.12 194.86 168.864C194.86 166.607 193.039 164.778 190.793 164.778C188.547 164.778 186.726 166.607 186.726 168.864C186.726 171.12 188.547 172.949 190.793 172.949Z",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.4427 95.9859L83.4309 87.9211L144.882 74.7554L155.543 76.4557L90.789 92.1837L90.5422 98.8079L83.4427 95.9859Z",
    fill: "#F89DBD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.963 81.8637C119.963 81.8637 108.256 53.4777 99.1227 61.7904C89.9898 70.1031 119.963 81.8637 119.963 81.8637Z",
    stroke: "#F89DBD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.963 81.8637C119.963 81.8637 131.67 53.4777 140.803 61.7904C149.936 70.1031 119.963 81.8637 119.963 81.8637Z",
    stroke: "#F89DBD",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_566"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 246.296,
    height: 190,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUniqueDesign);
export default __webpack_public_path__ + "static/media/UniqueDesign.1e2fafc259894d6da533139ba49d7f68.svg";
export { ForwardRef as ReactComponent };